import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import * as authService from '../../services/auth';

const ProtectedRoute = ({component: Component, redirectTo, ...rest}) => {
  return (
      <Route
          {...rest}
          render={props =>
              authService.isAuthenticated() === true ? (
                  <Component {...props} />
              ) : (
                  <Redirect
                      to={{
                        pathname: redirectTo ? redirectTo : '/admin/login',
                        state: {from: props.location},
                      }}
                  />
              )
          }
      />
  );
};

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute/ProtectedRoute.js